import Home from './components/Home/Home'
import AboutDetailed from "./components/Pages/About";
import HistoryDetailed from "./components/Pages/History";
import PuppyDetailed from "./components/Pages/Puppy";
// import NewsOverview from "./components/Pages/NewsOverview";
import Pictures from "./components/Pages/Pictures";
import MailSuccess from "./components/Pages/MailSuccess";
import MailFail from "./components/Pages/MailFail";
import NotFound from "./components/Pages/NotFound";
import MailDetailed from "./components/Pages/Media";

export default [
        {
            path: '/',
            component: Home,
            alias: ['/home', '/index']
        },
        {
            path: '/about',
            component: AboutDetailed,
            alias: ['/over', '/over-ons', '/about-us', '/wie']
        },
        {
            path: '/history',
            component: HistoryDetailed,
            alias: ['/geschiedenis', '/historie']
        },
        {
            path: '/puppy',
            component: PuppyDetailed,
            alias: ['/pup', '/pups', '/puppie']
        },
        // {
        //     path: '/news',
        //     component: NewsOverview,
        //     alias: ['/nieuws', '/nieuw', '/info', '/calendar', '/kalender', '/agenda']
        // },
        {
          path: '/photo',
          component: Pictures,
          alias: ['/foto', '/afbeeldingen', '/afbeelding', '/fotos', '/pictures', '/picture', '/img', '/image', '/images']
        },
        {
          path: '/media',
          component: MailDetailed
        },
        {
          path: '/mailsuccess',
          component: MailSuccess
        },
        {
          path: '/mailfail',
          component: MailFail
        },
        {
          path: "*",
          component: NotFound
        }
]